// extracted by mini-css-extract-plugin
export default {"contextMenu":"context-menu_contextMenu__omL6q"};